import React, { useCallback, useEffect, useMemo, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import {
    contraceptivesGivenRePortHeader,
} from "../components/HeaderAttribute";
import "jspdf-autotable";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { useLocation } from "react-router-dom";

const CommoditiesGivenReport = () => {
    const { userProfileState } = useUserCapability();
    const userProfileDatas = userProfileState.userProfile;

    const location = useLocation();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [branchName, setBranchName] = useState("");

    const [branchStockFields, setBranchStockFields] = useState({
        branchProject: "",
        sdp: "",
        area: "",
        orw: "",
        commodityType: "",
        commodityCategory: "",
        CommodityId: "",
    });
    const [branchStockFieldsError, setBranchStockFieldsError] = useState({
        sdpError: "",
        areaError: "",
        orwError: "",
        branchProjectError: "",
        commodityTypeError: "",
        commodityCategoryError: "",
        commodityError: "",
    });

    const [showTable, setShowTable] = useState(false);


    const [bindSDP, setBindSDP] = useState([]);
    const [getCommoditiesData, setGetCommoditiesData] = useState([]);
    const [getCommodityCategoryData, setGetCommodityCategoryData] = useState([]);
    const [bindCommodityId, setBindCommodityId] = useState([]);
    const [bindCommodityCategory, setBindCommodityCategory] = useState([]);
    const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
    const [bindCommodityData, setBindCommodityData] = useState([]);
    const [bindCommodityType, setBindCommodityType] = useState([]);
    const [bindUser, setBindUser] = useState([]);
    const [bindORWDD, setBindORWDD] = useState([]);
    const [bindArea, setBindArea] = useState([]);
    const [getAreaDatas, setGetAreaDatas] = useState([]);

    const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
    const [sdpNamesList, setSDPNamesList] = useState([]);
    const [ORSNamesList, setORSNamesList] = useState([]);

    const [areaNamesList, setAreaNamesList] = useState([]);

    const [commodityTypeNameList, setCommodityTypeNameList] = useState([]);
    const [commoditySubCategoryNameList, setcommoditySubCategoryNameList] =
        useState([]);
    const [commodityNameList, setCommodityNameList] = useState([]);

    useEffect(() => {
        if (
            userProfileDatas[0]?.MstOrganizationId == 2 ||
            userProfileDatas[0]?.MstOrganizationId == 3
        ) {
            setBranchName(userProfileDatas[0]?.LocationName_en);
            if (userProfileDatas[0]?.MstSDPId == null) {
                setBranchStockFields({
                    ...branchStockFields,
                    branchProject: [userProfileDatas[0]?.MstLocationId],
                    sdp: "",
                });
            } else {
                setBranchStockFields({
                    ...branchStockFields,
                    branchProject: [userProfileDatas[0]?.MstLocationId],
                    sdp: [userProfileDatas[0]?.MstSDPId],
                });
            }
        }
        // BranchProjectFetchData();
        // commodityTypeDD();
    }, [userProfileDatas ? userProfileDatas : undefined]);

    useEffect(() => {
        if (branchStockFields.sdp) {
            try {
                const getSelectedArea = async () => {
                    const locationResponse = await BindAPI("AreaAPI/GetArea");
                    setGetAreaDatas(locationResponse.data.Table);

                    const areaLabels = locationResponse.data.Table.filter((item) =>
                        branchStockFields.sdp.includes(item.MstSDPId)
                    ).map((item) => ({
                        MstAreaId: item.MstAreaId,
                        AreaName_en: item.AreaName_en,
                    }));

                    const areaSelected = areaLabels.map((AR) => ({
                        value: AR.MstAreaId,
                        label: AR.AreaName_en,
                    }));

                    setBindArea(areaSelected);
                };

                getSelectedArea();
            } catch (e) {
            }
        }
    }, [branchStockFields.sdp ? branchStockFields.sdp : undefined]);

    const GoButton = async () => {

        const branchProjectValidate = branchStockFields.branchProject
            ? ""
            : "Select Branch/Project";

        const commodityTypeValidate = branchStockFields.commodityType
            ? ""
            : "Select commodity type";
        const commodityCategoryValidate = branchStockFields.commodityCategory
            ? ""
            : "Select commodity category";
        const CommodityIdValidate = branchStockFields.CommodityId
            ? ""
            : "Select commodity";
        setBranchStockFieldsError({
            ...branchStockFieldsError,
            branchProjectError: branchProjectValidate,

            commodityTypeError: commodityTypeValidate,
            commodityCategoryError: commodityCategoryValidate,
            commodityError: CommodityIdValidate,
        });

        let branchProjectArray = Array.from(
            { length: branchStockFields.branchProject.length },
            (v, i) => branchStockFields.branchProject[i]
        );
        let branchProjectResult = branchProjectArray.join(",");





        let commodityTypeArray = Array.from(
            { length: branchStockFields.commodityType.length },
            (v, i) => branchStockFields.commodityType[i]
        );
        let commodityTypeResult = commodityTypeArray.join(",");

        let commodityCategoryArray = Array.from(
            { length: branchStockFields.commodityCategory.length },
            (v, i) => branchStockFields.commodityCategory[i]
        );
        let commodityCategoryResult = commodityCategoryArray.join(",");

        let commodityArray = Array.from(
            { length: branchStockFields.CommodityId.length },
            (v, i) => branchStockFields.CommodityId[i]
        );
        let commodityResult = commodityArray.join(",");

        if (
            !branchProjectValidate &&

            !commodityTypeValidate &&
            !commodityCategoryValidate &&
            !CommodityIdValidate
        ) {
            const ReportData =
            {
                mstBranchId: branchProjectResult,

                commodityTypeId: commodityTypeResult,
                commodityCategoryId: commodityCategoryResult,
                commodityId: commodityResult,

                fromDate: fromDate,
                toDate: toDate,
            }
                ;
            const response = await BindPostAPI(
                ReportData,
                "ContraceptivesGiven/ReportCommoditiesGiven"
            );

            setBindCommodityData(response.data.Table);
            setShowTable(true);
        } else {
        }
    };

    useEffect(() => {
        if (branchStockFields.branchProject) {
            const NameList = branchStockFields.branchProject
                .map(
                    (option) =>
                        bindBranchProjectDD?.find((item) => item.value === option)?.label
                )
                .filter(Boolean); // Remove undefined values if any
            setBranchProjectNamesList(NameList);
        }

        if (branchStockFields.sdp) {
            const NameList = branchStockFields.sdp
                .map((option) => bindSDP?.find((item) => item.value === option)?.label)
                .filter(Boolean); // Remove undefined values if any
            setSDPNamesList(NameList);
        }

        if (branchStockFields.area) {
            const NameList = branchStockFields.area
                .map((option) => bindArea?.find((item) => item.value === option)?.label)
                .filter(Boolean); // Remove undefined values if any
            setAreaNamesList(NameList);
        }

        if (branchStockFields.orw) {
            const NameList = branchStockFields.orw
                .map(
                    (option) => bindORWDD?.find((item) => item.value === option)?.label
                )
                .filter(Boolean); // Remove undefined values if any
            setORSNamesList(NameList);
        }

        if (branchStockFields.commodityType) {
            const NameList = branchStockFields.commodityType
                .map(
                    (option) =>
                        bindCommodityType?.find((item) => item.value === option)?.label
                )
                .filter(Boolean); // Remove undefined values if any
            setCommodityTypeNameList(NameList);
        }

        if (branchStockFields.commodityCategory) {
            const NameList = branchStockFields.commodityCategory
                .map(
                    (option) =>
                        bindCommodityCategory?.find((item) => item.value === option)?.label
                )
                .filter(Boolean); // Remove undefined values if any
            setcommoditySubCategoryNameList(NameList);
        }

        if (branchStockFields.CommodityId) {
            const NameList = branchStockFields.CommodityId.map(
                (option) =>
                    bindCommodityId?.find((item) => item.value === option)?.label
            ).filter(Boolean); // Remove undefined values if any
            setCommodityNameList(NameList);
        }
    }, [branchStockFields]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return `${date.getDate().toString().padStart(2, "0")}-${(
            date.getMonth() + 1
        )
            .toString()
            .padStart(2, "0")}-${date.getFullYear()}`;
    };

    const createdBy = sessionStorage.getItem("createdBy");

    const handleExport = async () => {
        try {
            const dateRange = {
                fromDate: fromDate,
                toDate: toDate,
            };

            const selectedOptionsData = {
                branchProjectData:
                    branchProjectNamesList.length > 0
                        ? branchProjectNamesList.toString()
                        : branchName,

                commodityTypeData: commodityTypeNameList.toString(),
                commodityCategoryData: commoditySubCategoryNameList.toString(),
                commodityIdData: commodityNameList.toString(),
            };

            // Export Function
            await exportDataLedger(
                contraceptivesGivenRePortHeader.map((column) => column.title),
                bindCommodityData,
                dateRange,
                selectedOptionsData
            );

            // ✅ Success Log
            await IUDAPI(
                {
                    mstUserId: parseInt(createdBy, 10),
                    sp: `Contraceptives Given Report`,
                    action: "Excel Export",
                    status: "SUCCESS",
                    tableName: null,
                    description: `Contraceptives Given Report Excel exported successfully From ${fromDate} to ${toDate}`,
                },
                "Log/IUDLog"
            );

            console.log(
                "Contraceptives Given Report Excel export completed successfully"
            );
        } catch (error) {
            console.error(
                "Contraceptives Given Report Excel export failed:",
                error
            );

            // ❌ Failed Log
            await IUDAPI(
                {
                    mstUserId: parseInt(createdBy, 10),
                    sp: `Contraceptives Given Report`,
                    action: "Excel Export",
                    status: "FAILED",
                    tableName: null,
                    description: `Contraceptives Given Report Excel export failed - ${error?.message || "Unknown Error"
                        }`,
                },
                "Log/IUDLog"
            );
        }
    };



    const exportDataLedger = (columns, rows, dateRange, selectedDetails) => {
        const titleRow = [
            {
                v: "Commodities Given Report",
                s: {
                    font: { bold: true, sz: 16 },
                    alignment: { horizontal: "left" },
                },
            },
        ];

        // Date range row with merged cells
        const dateRangeRow = [
            { v: "" },
            {
                v: "From Date:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "right" },
                },
            },
            {
                v: formatDate(dateRange.fromDate),
                s: {
                    alignment: { horizontal: "left" },
                },
            },
            {
                v: "To Date:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "left" },
                },
            },
            {
                v: formatDate(dateRange.toDate),
                s: {
                    alignment: { horizontal: "left" },
                },
            },
        ];

        // Branch information row with merged cells
        const branchRow = [
            { v: "" },
            {
                v: "Branch/Project:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "right" },
                },
            },
            {
                v: selectedDetails.branchProjectData,
                s: {
                    alignment: { horizontal: "left" },
                    alignment: { wrapText: true }, // Enable text wrapping
                },
            },


        ];

        // Branch information row with merged cells
        const commoditiesRow = [
            { v: "" },
            {
                v: "Commodity Type:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "right" },
                },
            },
            {
                v: selectedDetails.commodityTypeData,
                s: {
                    alignment: { horizontal: "left" },
                    alignment: { wrapText: true }, // Enable text wrapping
                },
            },

            {
                v: "Commodity Sub-Category:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "right" },
                },
            },
            {
                v: selectedDetails.commodityCategoryData,
                s: {
                    alignment: { horizontal: "left" },
                    alignment: { wrapText: true }, // Enable text wrapping
                },
            },

            {
                v: "Commodity:",
                s: {
                    font: { bold: true },
                    alignment: { horizontal: "right" },
                },
            },
            {
                v: selectedDetails.commodityIdData,
                s: {
                    alignment: { horizontal: "left" },
                    alignment: { wrapText: true }, // Enable text wrapping
                },
            },
        ];

        // Add empty row for spacing
        const spacingRow = [{ v: "" }];

        const headerRow = [
            ...columns.map((column) => ({
                v: column,
                s: {
                    fill: { fgColor: { rgb: "2D2D6E" } },
                    font: { bold: true, color: { rgb: "FFFFFF" } },
                    alignment: { horizontal: "left" },
                },
            })),
        ];

        const dataRows = rows.map((rowData, index) => {
            const isAlternateRow = index % 2 === 1;
            const baseStyle = isAlternateRow
                ? { fill: { fgColor: { rgb: "F0F0F0" } } }
                : {};

            return [
                {
                    v: index + 1,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },

                {
                    v: rowData.Date,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.MonthName,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.Year,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.EntityName,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.LocationName_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.SDP_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.AreaName_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.OutreachStaff,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.CommodityType_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.CommodityCategory_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.CommodityName_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.Brand_en,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.Batch,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.ExpiryDate,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.Quantity,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.CommodityUOM,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.Charges,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },
                {
                    v: rowData.CreatedBy,
                    s: { ...baseStyle, alignment: { horizontal: "left" } },
                },


            ];
        });

        // Combine all rows 
        const wsData = [
            titleRow,
            dateRangeRow,
            branchRow,
            commoditiesRow,
            spacingRow,
            headerRow,
            ...dataRows,
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Set custom column widths
        ws["!cols"] = [
            { width: 8 }, // Index
            { width: 20 }, // IPC  No
            { width: 30 }, // Gender
            { width: 30 }, // Gender
            { width: 30 }, // Gender
            { width: 30 }, // Gender
            { width: 30 }, // Topics1
            { width: 30 }, // Topics2
            { width: 30 }, // Topics3
            { width: 30 }, // Topics4
            { width: 30 }, // Topics5
            { width: 30 }, // Topics6
            { width: 30 }, // Topics7
            { width: 30 }, // Topics7
            { width: 15 }, // Topics8
            { width: 15 }, // Topics9
            { width: 15 }, // Topics10
            { width: 30 }, // Topics10
            { width: 30 }, // Topics10
            { width: 30 }, // Topics10
            { width: 30 }, // Topics10
        ];



        // Set row heights for wrapped content
        ws["!rows"] = [
            { hpt: 25 }, // Title row height
            { hpt: 15 }, // Date range row height
            { hpt: 15 }, // Branch row height (taller for wrapped content)
            { hpt: 15 }, // Spacing row height
            { hpt: 15 }, // Header row height (taller for wrapped content)
            ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
            { hpt: 15 }, // Totals row height
        ];

        // Apply borders and styles
        const applyStyles = (ws) => {
            const range = XLSX.utils.decode_range(ws["!ref"]);
            for (let R = range.s.r; R <= range.e.r; R++) {
                for (let C = range.s.c; C <= range.e.c; C++) {
                    const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!ws[cellRef]) continue;

                    // Add borders to all cells
                    ws[cellRef].s = {
                        ...ws[cellRef].s,
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } },
                        },
                    };
                }
            }
        };

        applyStyles(ws);

        // Create the workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Export the Excel file
        XLSX.writeFile(wb, "Commodities Given Report.xlsx");
    };
    const downloadPDF = () => {

    };

    const fetchUsers = useCallback(async () => {
        try {
            const profile = userProfileDatas?.[0];
            if (!profile) return;

            const data = {
                mstOrganizationStructureId: profile.MstOrganizationId,
                mstBranchId: profile.MstLocationId,
                mstSdpId: profile.MstSDPId ?? 0,
                mstUserId: profile.MstUserId,
                mstRoleId: profile.MstRoleId,
            };

            const res = await BindPostAPI(data, "UserAPI/BindUser");

            const source =
                profile.MstOrganizationId === 3
                    ? res?.data?.Table
                    : res?.data?.Table2;

            const filtered = (source || []).filter(
                item => item.MstRoleId === 7
            );

            const uniqueUsers = [
                ...new Map(filtered.map(u => [u.MstUserId, u])).values()
            ];

            setBindUser(uniqueUsers);
        } catch (e) {
            console.error("fetchUsers error", e);
        }
    }, [userProfileDatas]);
    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);
    useEffect(() => {
        const init = async () => {
            try {
                const [
                    locationRes,
                    commodityTypeRes,
                    commodityCatRes,
                    commoditiesRes
                ] = await Promise.all([
                    BindAPI("LocationAPI/GetLocation"),
                    BindAPI("InventoryReceiptAPI/BindCommodityType"),
                    BindAPI("CommoditiesAPI/GetCommoditiesCategory"),
                    BindAPI("CommoditiesAPI/BindCommodities")
                ]);

                setBindBranchProjectDD(
                    locationRes.data.Table.map(i => ({
                        value: i.MstLocationId,
                        label: i.LocationName_en,
                    }))
                );

                setBindCommodityType(
                    commodityTypeRes.data.Table.map(i => ({
                        value: i.MstCommodityTypeId,
                        label: i.CommodityType_en,
                    }))
                );

                setGetCommodityCategoryData(commodityCatRes.data.Table);
                setGetCommoditiesData(commoditiesRes.data.Table);
            } catch (e) {
                console.error("Init data error", e);
            }
        };

        init();
    }, []);
    useEffect(() => {
        const today = new Date();
        setFromDate(`${today.getFullYear()}-01-01`);
        setToDate(today.toISOString().split("T")[0]);
    }, []);
    useEffect(() => {
        if (!branchStockFields.branchProject?.length) return;

        const fetchSDP = async () => {
            const res = await BindAPI("SDPAPI/GetSDP");
            const profile = userProfileDatas?.[0];
            if (!profile) return;

            const sdpOptions = res.data.Table
                .filter(item =>
                    branchStockFields.branchProject.includes(+item.MstLocationId)
                )
                .map(item => ({
                    value: item.MstSDPId,
                    label: item.SDP_en,
                }));

            if ([1, 2].includes(profile.MstOrganizationId)) {
                setBindSDP(sdpOptions);
            } else {
                const allowed = profile.AllSDP ?? profile.MstSDPId;
                setBindSDP(
                    sdpOptions.filter(s =>
                        Array.isArray(allowed)
                            ? allowed.includes(s.value)
                            : allowed === s.value
                    )
                );
            }
        };

        fetchSDP();
    }, [branchStockFields.branchProject, userProfileDatas]);
    const commodityCategoryOptions = useMemo(() => {
        if (!branchStockFields.commodityType?.length) return [];

        return getCommodityCategoryData
            .filter(i =>
                branchStockFields.commodityType.includes(i.MstCommodityTypeId)
            )
            .map(i => ({
                value: i.MstCommodityCategoryId,
                label: i.CommodityCategory_en,
            }));
    }, [branchStockFields.commodityType, getCommodityCategoryData]);

    useEffect(() => {
        setBindCommodityCategory(commodityCategoryOptions);
    }, [commodityCategoryOptions]);
    const commodityOptions = useMemo(() => {
        if (!branchStockFields.commodityCategory?.length) return [];

        return getCommoditiesData
            .filter(i =>
                branchStockFields.commodityCategory.includes(i.MstCommodityCategoryId)
            )
            .map(i => ({
                value: i.MstCommoditiesId,
                label: i.CommodityName_en,
            }));
    }, [branchStockFields.commodityCategory, getCommoditiesData]);

    useEffect(() => {
        setBindCommodityId(commodityOptions);
    }, [commodityOptions]);
    const orwOptions = useMemo(() => {
        if (!branchStockFields.sdp?.length) return [];

        return bindUser
            .filter(u => branchStockFields.sdp.includes(u.MstSDPId))
            .map(u => ({
                value: u.MstUserId,
                label: `${u.FirstName_en} ${u.LastName_en}`,
            }));
    }, [branchStockFields.sdp, bindUser]);

    useEffect(() => {
        setBindORWDD(orwOptions);
    }, [orwOptions]);
    const branchStockFieldsChange = (value, name) => {
        setShowTable(false);

        setBranchStockFields(prev => {
            let updated = { ...prev, [name]: value };

            // 👉 When Commodity Type changes
            if (name === "commodityType") {
                updated.commodityCategory = "";
                updated.CommodityId = "";
            }

            // 👉 When Commodity Sub-Category changes
            if (name === "commodityCategory") {
                updated.CommodityId = "";
            }

            return updated;
        });
    };

    useEffect(() => {
        if (location.pathname == "/commoditiesgivenreport") {
            setShowTable(false);
        }
    }, [location]);


    return (
        <MainLayout pageName="4">
            <div>
                <div class="relative m-3 bg-white rounded-lg ">
                    <div class="mt-3 py-4">

                        <div className={mainTable.headerTitle}>
                            <div className="my-2 mx-12 lg:mx-0">
                                {`Commodities Given Report`}
                            </div>
                        </div>
                        <div className={mainTable.grid4}>
                            {userProfileDatas[0]?.MstOrganizationId == 1 && (
                                <div>
                                    <MultiSelect
                                        classStar="text-red-500"
                                        label="Branch/Project"
                                        filteredOptions={bindBranchProjectDD}
                                        classFilterLabel="p-1 flex gap-1"
                                        class="custom-class"
                                        placeholder={
                                            branchStockFields.branchProject?.length > 0
                                                ? "More Selected"
                                                : "Select..."
                                        }
                                        name="branchProject"
                                        selectedOptions={branchStockFields.branchProject}
                                        classDiv="relative w-full inline-block"
                                        onChange={(e) => {
                                            setShowTable(false);
                                            branchStockFieldsChange(e, "branchProject");
                                        }}
                                        classLabel={mainTable.labelNoWrap}
                                    />
                                    {branchStockFieldsError.branchProjectError && (
                                        <span className="text-red-500">
                                            {branchStockFieldsError.branchProjectError}
                                        </span>
                                    )}
                                </div>
                            )}
                            {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                                userProfileDatas[0]?.MstOrganizationId == 3) && (
                                    <InputText
                                        inputType="text"
                                        title="Branch/Project"
                                        classStar="text-red-500"
                                        name="branchName"
                                        disabled="true"
                                        content={branchName}
                                        controlFunc={(e) => setBranchName(e.target.value)}
                                    />
                                )}

                            <div>
                                <MultiSelect
                                    classStar="text-red-500"
                                    label="Commodity Type"
                                    filteredOptions={bindCommodityType}
                                    classFilterLabel="p-1 flex gap-1"
                                    class="custom-class"
                                    placeholder={
                                        branchStockFields.commodityType?.length > 0
                                            ? "More Selected"
                                            : "Select..."
                                    }
                                    name="commodityType"
                                    selectedOptions={branchStockFields.commodityType}
                                    classDiv="relative w-full inline-block"
                                    onChange={(e) => {
                                        setShowTable(false);
                                        branchStockFieldsChange(e, "commodityType");
                                    }}
                                    classLabel={mainTable.labelNoWrap}
                                />
                                {branchStockFieldsError.commodityTypeError && (
                                    <span className="text-red-500">
                                        {branchStockFieldsError.commodityTypeError}
                                    </span>
                                )}
                            </div>
                            <div>
                                <MultiSelect
                                    classStar="text-red-500"
                                    label="Commodity Sub-Category"
                                    filteredOptions={bindCommodityCategory}
                                    classFilterLabel="p-1 flex gap-1"
                                    class="custom-class"
                                    placeholder={
                                        branchStockFields.commodityCategory?.length > 0
                                            ? "More Selected"
                                            : "Select..."
                                    }
                                    name="commodityCategory"
                                    selectedOptions={branchStockFields.commodityCategory}
                                    classDiv="relative w-full inline-block"
                                    onChange={(e) => {
                                        setShowTable(false);
                                        branchStockFieldsChange(e, "commodityCategory");
                                    }}
                                    classLabel={mainTable.labelNoWrap}
                                />
                                {branchStockFieldsError.commodityCategoryError && (
                                    <span className="text-red-500">
                                        {branchStockFieldsError.commodityCategoryError}
                                    </span>
                                )}
                            </div>
                            <div>
                                <MultiSelect
                                    classStar="text-red-500"
                                    label="Commodity"
                                    filteredOptions={bindCommodityId}
                                    classFilterLabel="p-1 flex gap-1"
                                    class="custom-class"
                                    placeholder={
                                        branchStockFields.CommodityId?.length > 0
                                            ? "More Selected"
                                            : "Select..."
                                    }
                                    name="CommodityId"
                                    selectedOptions={branchStockFields.CommodityId}
                                    classDiv="relative w-full inline-block"
                                    onChange={(e) => {
                                        setShowTable(false);
                                        branchStockFieldsChange(e, "CommodityId");
                                    }}
                                />
                                {branchStockFieldsError.commodityError && (
                                    <span className="text-red-500">
                                        {branchStockFieldsError.commodityError}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div class={mainTable.grid3}>
                            <InputText
                                inputType="date"
                                title="From"
                                name="fromDate"
                                content={fromDate}
                                controlFunc={(e) => {
                                    setShowTable(false);
                                    setFromDate(e.target.value);
                                }}
                            />

                            <InputText
                                inputType="date"
                                title={"To"}
                                name="toDate"
                                content={toDate}
                                controlFunc={(e) => {
                                    setShowTable(false);
                                    setToDate(e.target.value);
                                }}
                            />
                            <div class="flex justify-start items-center mt-6">
                                <button
                                    type="button"
                                    onClick={() => GoButton()}
                                    className={mainTable.addButton}
                                >
                                    GO
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {showTable &&
                    (bindCommodityData.length > 0 ? (
                        <div className=" ">
                            <ReportGridPage
                                title=""
                                header={contraceptivesGivenRePortHeader}
                                records={bindCommodityData}
                                handleExport={handleExport}
                                handlePDF={downloadPDF}
                            />
                        </div>
                    ) : (
                        <div className="flex items-center justify-center">
                            No record found
                        </div>
                    ))}
            </div>
        </MainLayout>
    );
};

export default CommoditiesGivenReport;
